import {Component, OnInit} from '@angular/core';
import {ReferInfo} from "../../core/referrals/refer-info";
import {Environment} from "../../core/environment-core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivationModalComponent} from "../promociones/quantum/activation-modal-component";
import {ActivationReferModalComponent} from "./activation-refer-modal-component";
import {ReferralsService} from "../../core/referrals/referrals.service";
import {Router} from "@angular/router";
import {ReferInfoResponse} from "../../core/referrals/refer-info-response";

@Component({
    selector: 'app-refer-list',
    templateUrl: './refer-list.component.html',
    styleUrls: ['./refer-list.component.scss']
})
export class ReferListComponent implements OnInit {

    refers: ReferInfoResponse[] = [];
    loading = false;

    constructor(public environment: Environment,
                private modalService: NgbModal,
                private router: Router,
                private referralsService: ReferralsService) {
        this.getReferrals();
    }

    ngOnInit() {
    }

    changeStatus(refer) {
        const modalRef = this.modalService.open(ActivationReferModalComponent, {backdrop: 'static'});
        modalRef.componentInstance.refer = refer;
        modalRef.result.then((result) => {
            console.log(result);
        }, (reason) => {
            console.log(reason);
        });
    }

    getReferrals() {
        this.loading = true;
        this.referralsService.getRefersList().subscribe(
            (response) => {
                this.refers = response;
                console.log(this.refers);
                this.loading = false;
            },
            (error) => {
                console.log('getReferrals:error');
                console.log(error);
                this.loading = false;
            }
        );
    }

    goToReferral(referralKey: string) {
        this.router.navigate(['/ganalottodo/refer/' + referralKey]);
    }

    addRefer() {
        this.router.navigate(['/ganalottodo/refer/new']);
    }

    builtUrl(refer: ReferInfoResponse): string {
        let url = '';
        if (refer.generalInfo.utmSource && refer.generalInfo.utmSource.length > 0) {
            url = url + '&utm_source=' + refer.generalInfo.utmSource;
        }
        if (refer.generalInfo.utmMedium && refer.generalInfo.utmMedium.length > 0) {
            url = url + '&utm_medium=' + refer.generalInfo.utmMedium;
        }
        if (refer.generalInfo.utmCampaign && refer.generalInfo.utmCampaign.length > 0) {
            url = url + '&utm_campaign=' + refer.generalInfo.utmCampaign;
        }
        if (refer.generalInfo.utmTerm && refer.generalInfo.utmTerm.length > 0) {
            url = url + '&utm_term=' + refer.generalInfo.utmTerm;
        }
        if (refer.generalInfo.utmContent && refer.generalInfo.utmContent.length > 0) {
            url = url + '&utm_content=' + refer.generalInfo.utmContent;
        }
        return url;
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/referrals/refer-list.component.ts